/** Request failures keep the retry UI without reporting a code fault to Bugsnag. */
export class MapLoadError extends Error {}
